import { getGlobalState, makeScopedState } from './initialize';
let __instance;
export const getScopedStateInstance = () => {
  if (!__instance) {
    const globalState = getGlobalState();
    if (!globalState) {
      throw Error('Global state not initialized — did you forget to call initializeGlobalState?');
    }
    __instance = Object.assign({}, globalState, {
      EXECUTION_CONTEXT: makeScopedState()
    });
  }
  return __instance;
};
export const getStateFor = scope => getScopedStateInstance()[scope];
export const TEST_ONLY_resetScopedStateInstance = () => {
  __instance = undefined;
};